<div class="wrapper-inner no-overflow-x">
  <div class="container not-found">
    <h1 class="title">Party Foul! That page doesn't exist!</h1>
    <p class="description">Don't Worry, be Hoppy! Let's find what Ales you.</p>

    <div class="search--container">
      <app-search></app-search>
    </div>
  </div>

  <img
    class="not-found--image"
    src="/assets/img/beer_glass.jpg"
    alt="Glass of beer"
  />
</div>
<app-footer></app-footer>
<app-back-top position="200"></app-back-top>
